export const BuildInfo = {timestamp:1774569184000}
